module.exports = __webpack_public_path__ + "img/edit_black_24dp.0833fddf.svg";